module.exports = __webpack_public_path__ + "media/images/athletes/1714-0304a5f4edad3e0fac1793107d71cd1e.png";